
class Constants{

    /**
     * The default mode of message dispatch
     * @type {string}
     */
    static DefaultDispatchMode = 'sms';

    /**
     * The full name of the company
     * @type {string}
     */
    static AppCompanyName =  process.env.REACT_APP_COMPANY_NAME || 'ECOFARMER';

    /**
     * The shortened name of the company
     * @type {string}
     */
    static AppCompanyNameShort = process.env.REACT_APP_COMPANY_NAME_SHORT || 'TTL';

    /***
     * The company website url
     * @type {*|string}
     */
    static AppCompanyWebsite = process.env.REACT_APP_COMPANY_WEBSITE || 'https://www.ecofarmer.co.zw';

    /**
     * The title prefix of the document
     */
    static AppTitlePrefix = `${Constants.AppCompanyName} - `;

    /**
     * Farm size unit
     * @type {string|string}
     */
    static FarmSizeUnit= process.env.REACT_APP_FARM_SZE_UNIT || "hectare";

    /**
     * The default maximum items per page
     * @type {number}
     */
    static MaxItemsPerPage = 10;

    /**
     * The tag for profile images
     * @type {string}
     */
    static ProfileImageTag = 'img-profile';

    /**
     * The minimum length of user passwords
     * @type {number}
     */
    static MinPasswordLength = 6;

    /**
     * The minimum username length
     * @type {number}
     */
    static MinUsernameLength = 2;

    /**
     * The default interval for refreshing the map view
     * @type {number}
     */
    static DefaultMapViewRefreshInterval = process.env.REACT_APP_MAP_VIEW_REFRESH_INTERVAL ? Number(process.env.REACT_APP_MAP_VIEW_REFRESH_INTERVAL) : 20025;

    /**
     * The ` required length of SMS token
     * @type {number}
     */
    static SmsTokenLength = 6;


    /**
     * The length
     * @type {number}
     */
    static  EmailTokenLength = 6;


    /**
     * The valid token lengths
     */
    static ValidTokenLengths = [
        Constants.SmsTokenLength,
        Constants.EmailTokenLength
    ];

    /**
     * The maximum size in bytes for profile images
     * @type {number}
     */
    static MaxProfileImageSize = 5000000;

    /**
     * The year on the footer
     */
    static ApplicationYear = process.env.REACT_APP_YEAR || (new Date().getFullYear());

    /**
     * The currency code for the application
     */
    static CurrencyCode = process.env.REACT_APP_CURRENCY_CODE || "KES";

    /**
     * Include segmented request cost
     * @type {boolean}
     */
    static IncludeSegmentedRequestCost = process.env.REACT_APP_INCLUDE_SEGMENTED_REQUEST_COST === 'true';

    /**
     * The two letter country ISO code used by places input
     * @type {*|string}
     */
    static PlacesAutoCompleteCountry = process.env.REACT_APP_PLACES_INPUT_COUNTRY || "ke";

    /**
     * Phone number example
     * @type {*|string}
     */
    static PhoneNumberExample = process.env.REACT_APP_PHONE_NUMBER_EXAMPLE || "+254120000XXX or 07120000XXX";

    /**
     * The country dialing code
     * @type {*|string}
     */
    static CountryDialingCode = process.env.REACT_APP_COUNTRY_DIALING_CODE || "+254";

    /**
     * The phone number region
     * @type {*|string}
     */
    static CountryPhoneRegionCode =  process.env.REACT_APP_COUNTRY_PHONE_CODE || "KE";

    /**
     * An
     * @type {*|string}
     */
    static NameExample = process.env.REACT_APP_NAME_EXAMPLE || "William";


    /**
     * An example location
     * @type {*|string}
     */
    static LocationExample = process.env.REACT_APP_LOCATION_EXAMPLE || "Nairobi";

    /**
     * Supported crops
     * @type {*|Array}
     */
    static Crops = process.env.REACT_APP_FARMER_CROPS ? process.env.REACT_APP_FARMER_CROPS.split(",") : [];

    /**
     * Default Map Coordinates
     * @type {{lng: number, lat: number}}
     */
    static DefaultMapCoordinates = { lat: -19.0169211 , lng: 29.1528018 };

    /**
     * Driver license classes
     */
    static LicenseClasses = process.env.REACT_APP_LICENSE_CLASSES ? process.env.REACT_APP_LICENSE_CLASSES.split(",") : [ "Unspecified" ];

    /**
     * Flutterwave API Key
     */
    static FlutterwaveApiKey = process.env.REACT_APP_FLUTTERWAVE_API_KEY;

    /**
     * Location component
     * @type {{level1: string, level3: string, level2: string}}
     */
    static LocationComponent = {
        level1: process.env.REACT_APP_LOCATION_COMP1,
        level2: process.env.REACT_APP_LOCATION_COMP2,
        level3: process.env.REACT_APP_LOCATION_COMP3
    };
}

export default Constants;



// WEBPACK FOOTER //
// ./src/common/AppVariables.js